import React from 'react';
import { Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { History, Lock, LockOpen, Download, Delete } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface UserActionsMenuProps {
  anchorEl: HTMLElement | null;
  selectedUser: any;
  onClose: () => void;
  onViewActivity: (user: any) => void;
  onSuspendClick: () => void;
  onUnsuspendClick: (userId: string) => void;
  onExportData: (userId: string) => void;
  onDeactivateClick: (userId: string) => void;
}

const UserActionsMenu: React.FC<UserActionsMenuProps> = ({
  anchorEl,
  selectedUser,
  onClose,
  onViewActivity,
  onSuspendClick,
  onUnsuspendClick,
  onExportData,
  onDeactivateClick,
}) => {
  const { t } = useTranslation();

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
    >
      <MenuItem onClick={() => {
        onViewActivity(selectedUser);
        onClose();
      }}>
        <ListItemIcon><History /></ListItemIcon>
        <ListItemText>{t('admin.viewActivity')}</ListItemText>
      </MenuItem>
      
      {selectedUser?.status === 'active' && (
        <MenuItem onClick={() => {
          onClose();
          onSuspendClick();
        }}>
          <ListItemIcon><Lock /></ListItemIcon>
          <ListItemText>{t('admin.suspendUser')}</ListItemText>
        </MenuItem>
      )}
      
      {selectedUser?.status === 'suspended' && (
        <MenuItem onClick={() => {
          onClose();
          onUnsuspendClick(selectedUser.id);
        }}>
          <ListItemIcon><LockOpen /></ListItemIcon>
          <ListItemText>{t('admin.unsuspendUser')}</ListItemText>
        </MenuItem>
      )}
      
      <MenuItem onClick={() => {
        onClose();
        onExportData(selectedUser.id);
      }}>
        <ListItemIcon><Download /></ListItemIcon>
        <ListItemText>{t('admin.exportUserData')}</ListItemText>
      </MenuItem>
      
      {selectedUser?.status !== 'deactivated' && (
        <MenuItem onClick={() => {
          onClose();
          onDeactivateClick(selectedUser.id);
        }} sx={{ color: 'error.main' }}>
          <ListItemIcon><Delete /></ListItemIcon>
          <ListItemText>{t('admin.deactivateUser')}</ListItemText>
        </MenuItem>
      )}
    </Menu>
  );
};

export default UserActionsMenu;